import { CompanyRole } from '@interfaces/companyRole.interface';

import api from './';

export const { useGetCompanyRoleQuery } = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyRole: build.query<CompanyRole[], string>({
      query: (marketCategoryName) => ({
        url: 'company-role',
        params: { marketCategoryName },
      }),
    }),
  }),
});
